import { create } from 'zustand';
import { DateRange, getEndOfWeekDate, getStartOfWeekDate } from 'utils/dateTimeFormat';

const getCurrentDateRange = (): DateRange => {
    const currentDate = new Date();

    return {
        endDate: getEndOfWeekDate(currentDate),
        startDate: getStartOfWeekDate(currentDate),
    };
};

interface DateRangeState {
    dateRange: DateRange;
    setDateRange: (range: DateRange) => void;
    resetDateRange: () => void;
}

export const useDateRangeStore = create<DateRangeState>((set) => ({
    dateRange: getCurrentDateRange(),
    setDateRange: (range) => set({ dateRange: range }),
    resetDateRange: () => set({ dateRange: getCurrentDateRange() }),
}));
